import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalTenantMgmtListComponent } from './external-tenant-mgmt-list.component';
import { ExternalTenantMgmtListRoutingModule } from 'src/app/main/external-tenant-mgmt-list/external-tenant-mgmt-list-routing.module';
import { BreadcrumbModule } from '../../components/breadcrumb/breadcrumb.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from '../../icons/icons.module';
import { TableModule } from 'src/app/table/table.module';
import { LeftSideNavigationModule } from 'src/app/layout/left-side-navigation/left-side-navigation.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { CreateTenant20Component } from './create-tenant2.0/create-tenant2.0.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { ErrorModule } from 'src/app/components/error/error.module';

@NgModule({
  declarations: [
    ExternalTenantMgmtListComponent,
    CreateTenant20Component
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    ExternalTenantMgmtListRoutingModule,
    IconsModule,
    ErrorModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    LeftSideNavigationModule,
    MatProgressSpinnerModule,
    SidenavHeaderModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    ToolbarModule,
    PaginatorModule
  ]
})
export class ExternalTenantMgmtListModule { }
